import AuthWall from '../../../../components/auth-wall';
import '../networkAnalysisPage.scss';
import './generate-report.scss';
import {observer} from 'mobx-react';
import {Navigate, useSearchParams} from 'react-router-dom';
import useGenerateReportController from './useGenerateReportController';
import {Button, ToastNotification} from '@carbon/react';
import {DocumentExport} from '@carbon/icons-react';
import GeneratedReport from './components/GeneratedReport';
import ReportProgressBar from './components/ReportProgressBar';
import {useState, useContext} from 'react';
import {NetworkContext} from '../../lib/context';


function GenerateReport() {
    const [searchParams] = useSearchParams();
    const standardType = searchParams.get('standard_type') || '';
    const standardVersion = searchParams.get('standard_version') || '';
    const networkOptimizationStore = useContext(NetworkContext);

    const {
        data: {
            rosterId,
            clientName,
            mapsLoading,
            tablesLoading,
            specialtyGroupings,
            maxTimeDistData,
            providerAvgTimeDistData,
            facilityAvgTimeDistData,
            allSpecialtyCountyData
        },
        methods: {
            printReport
        }
    } = useGenerateReportController();

    const [mapsProgress, setMapsProgress] = useState({current: 0, total: 0});
    const [isProgressBarVisible, setIsProgressBarVisible] = useState(true);

    if (!rosterId) return <Navigate to="/network-optimization/my-files" replace />;

    return (
        <AuthWall>
            <>
                <div className="network-analysis-page generate-report-page pt-5 bg-white border-b border-background-gray-200 items-center">
                    <ReportProgressBar
                        current={mapsProgress.current}
                        total={mapsProgress.total}
                        onVisibilityChange={setIsProgressBarVisible}
                    />
                    <div className={`flex justify-end export-button ${isProgressBarVisible ? 'with-progress-bar' : ''}`}>
                        <Button
                            renderIcon={DocumentExport}
                            onClick={printReport}
                            disabled={mapsLoading || tablesLoading}
                        >
                            Export
                        </Button>
                    </div>
                    <GeneratedReport
                        clientName={clientName}
                        specialtyGroupings={specialtyGroupings}
                        maxTimeDistData={maxTimeDistData}
                        providerAvgTimeDistData={providerAvgTimeDistData}
                        facilityAvgTimeDistData={facilityAvgTimeDistData}
                        allSpecialtyCountyData={allSpecialtyCountyData}
                        standardType={standardType}
                        standardVersion={standardVersion}
                        onMapsProgressChange={setMapsProgress}
                    />
                </div>

                {/* Toast Notification - errors don't auto-close */}
                {networkOptimizationStore.showToast && (
                    <ToastNotification
                        aria-label="closes notification"
                        caption=""
                        kind={networkOptimizationStore.toastKind}
                        onClose={() => networkOptimizationStore.hideToastNotification()}
                        onCloseButtonClick={() => networkOptimizationStore.hideToastNotification()}
                        role="alert"
                        statusIconDescription="notification"
                        subtitle={networkOptimizationStore.toastSubtitle}
                        timeout={networkOptimizationStore.toastKind === 'error' ? 0 : 5000}
                        title={networkOptimizationStore.toastTitle}
                        style={{
                            position: 'fixed',
                            top: '3rem',
                            right: '1rem',
                            zIndex: 9999,
                            minWidth: '350px',
                            maxWidth: '500px'
                        }}
                    />
                )}
            </>
        </AuthWall>
    );
}

export default observer(GenerateReport);
